<template>
  <div>
    <div class="articles-list">
      <div class="articles-list-heading">
        <!--Library contains 51 Articles	24 Published 0 Archived 27 Draft
Add new article WILL BE HERE COMPONENT-->
      </div>
    </div>

    <div class="articles-list-body">
      <!-- .table table-data -->
      <table class="table table-data">
        <thead>
        <tr>
         <th class="cellpadding column-id-head table-head-ceil">
           <articleId></articleId>
         </th>
          <th class="articles-list-search-col text-left column-search-head table-head-ceil"
              :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 1}">
            <searchInArticles></searchInArticles>
          </th>
          <th class="column-lng-head table-head-hover table-head-ceil"
              :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 2,
                'active-ceil-head': filerTableHead.selectedCeil === 1,
                'hover-head-ceil': isExistInOptions(getLanguagesForSelect)}"
              @mouseover="addHoverElement(getLanguagesForSelect)"
              @mouseleave="removeHoverElements">
            <languageArticles></languageArticles>
          </th>
          <th>
            <typeArticles></typeArticles>
          </th>
          <th>
            <topicsArticle></topicsArticle>
          </th>
          <th>
            <categoryArticles></categoryArticles>
          </th>
          <th>
            <accessArticle></accessArticle>
          </th>
          <th>
            <companySpecificArticles></companySpecificArticles>
          </th>
          <th>
            <lastEditedArticles></lastEditedArticles>
          </th>
          <th>
            <uploaderEditorArticles></uploaderEditorArticles>
          </th>
          <th>
            <statusArticles></statusArticles>
          </th>
          <th colspan="3">
            <actionsArticles></actionsArticles>
          </th>
        </tr>
        </thead>
        <tbody>
            <tr>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>6</td>
              <td>7</td>
              <td>8</td>
              <td>9</td>
              <td>10</td>
              <td>
               </td>
              <td class="cellpadding">
                <button
                  type="button"
                  class="table-crud-btn icon-btn"
                  @click="editArticle(article.id)">
                  <icon name="pencil"/>
                  <span class="table-tooltip-edit">Edit</span>
                </button>
              </td>
              <!--<td class="cellpadding">-->
                <!--<button-->
                <!--type="button"-->
                <!--class="table-crud-btn icon-btn"-->
                <!--v-if="article.status !== 2"-->
                <!--@click="initAction('changeStatusArticle', {articleId: article.id, status: 2, i: i})">-->
                <!--<icon name="folder" />-->
                <!--</button>-->
                <!--<button-->
                  <!--type="button"-->
                  <!--class="table-crud-btn icon-btn"-->
                  <!--v-if="article.status === 2"-->
                  <!--@click="initAction('changeStatusArticle', {articleId: article.id, status: 1, i: i})">-->
                  <!--<icon name="rotate-right" />-->
                <!--</button>-->
                <!--</td>-->
              <td class="cellpadding">
                <button
                type="button"
                class="table-crud-btn icon-btn"
                @click="initAction('removeArticle', {articleId: article.id, i: i})">
                  <icon name="times" />
                </button>
              </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import articleId from '@/components/newCmsStyle/ComponentArticle/articlesId'
import searchInArticles from '@/components/newCmsStyle/ComponentArticle/searchInArticles'
import languageArticles from '@/components/newCmsStyle/ComponentArticle/languageArticles'
import typeArticles from '@/components/newCmsStyle/ComponentArticle/typeArticles'
import topicsArticle from '@/components/newCmsStyle/ComponentArticle/topicsArticles'
import categoryArticles from '@/components/newCmsStyle/ComponentArticle/categoryArticles'
import accessArticle from '@/components/newCmsStyle/ComponentArticle/accessArticles'
import companySpecificArticles from '@/components/newCmsStyle/ComponentArticle/companySpecificArticles'
import lastEditedArticles from '@/components/newCmsStyle/ComponentArticle/lastEditedArticles'
import uploaderEditorArticles from '@/components/newCmsStyle/ComponentArticle/uploaderEditorArticles'
import statusArticles from '@/components/newCmsStyle/ComponentArticle/statusArticles'
import actionsArticles from '@/components/newCmsStyle/ComponentArticle/actionsArticles'
/* -------------------------------------------------- */
import api from '@/api'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/pencil'
import 'vue-awesome/icons/folder'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/rotate-right'
import AppSelect from '@/components/admin/common/Select'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'articles-list',
  data () {
    return {
      articles: [],
      getArticleListActions: ['Action 1', 'Action 2', 'Action 3'],
      selectedAction: null,
      lngs: ['English (UK)', 'English (US)'],
      confirmation: {
        action: '',
        isShown: false,
        articleId: null,
        i: null,
        style: {
          top: '100px'
        }
      },
      contentAutoloadInfo: {
//        curPage: 1,
        numPages: 1,
        locked: false
      },
      search: '',
      languages: [],
      contentType: [],
      tags: [],
      categories: [],
      roles: [],
      companies: [],
      lastEdited: [],
      lastEditors: [],
      status: [],
      statusOptions: [],
      lastEditorsOptions: [],
      datepicker: {
        from: null,
        to: null
      },
      statusbar: {
        published: 0,
        archived: 0,
        draft: 0,
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      }
    }
  },
  methods: {
    ...mapActions([
      'getTypes',
      'getTags',
      'getCategories',
      'getCompanies',
      'getRoles',
      'getLngs'
    ]),
    initAction (name, payload) {
      this.confirmation.action = name
      Object.keys(payload).forEach((key) => {
        this.confirmation[key] = payload[key]
      })
      this.confirmation.isShown = true
    },
    clearAction () {
      this.confirmation.isShown = false
      Object.keys(this.confirmation).forEach((key) => {
        if (key !== 'isShown' && key !== 'style') {
          this.confirmation[key] = null
        }
      })
    },
    confirmActionHandler () {
      let self = this
      switch (this.confirmation.action) {
        case 'removeArticle':
          removeArticle(this.confirmation.articleId, this.confirmation.i)
          break
        case 'changeStatusArticle':
          changeStatusArticle(this.confirmation.articleId, this.confirmation.status, this.confirmation.i)
          break

      }
      function removeArticle (articleId, i) {
        self.clearAction()
        self.$http.delete(api.URLS.content + '/' + articleId, api.headersAuthSettings)
          .then((res) => {
            self.clearAction()
            self.articles.splice(i, 1)
            alert('Article has been successfully removed')
          })
          .catch((err) => console.log(err))
      }
      function changeStatusArticle (articleId, status, i) {
        self.clearAction()
        let body = {
          status: status,
          isArticle: true
        }
        self.$http.post(api.URLS.changeStatus + '/' + articleId, body, api.headersAuthSettings)
          .then((res) => {
            self.clearAction()
            let status = res.body.data.status
            self.articles[i].status = status
// set article count
            let statuses = res.body.statuses
            self.statusbar.published = statuses.Published.count
            self.statusbar.draft = statuses.Draft.count
            self.statusbar.archived = statuses.Archived.count
            console.log(res)
          })
          .catch((err) => console.log(err))
      }
    },
    // TODO: Change scrool handler make cur page different for different search typeFdelete
    handleScroll (event) {
      if (!this.articles.length) return

      if (this.search) {
        this.page = 1
        this.mainSearch(++this.contentAutoloadInfo.curPage, 20)
      } else {
        this.page = 1
        this.searchByParams(++this.contentAutoloadInfo.curPage, 20)
      }
    },
    editArticle (id) {
      this.$router.push({path: `/admin/article/edit/${id}`})
    },
    mainSearch (page, limit) {
      if (!this.search) {
        this.searchByParams(1, 20)
        return
      }
// filter by languages
      let subLanguages = ''
      this.languages.forEach((lng, i) => {
        subLanguages += `&language[${i}]=${lng.value}`
      })
      let subTag = ''
      this.tags.forEach((tag, i) => {
        subTag += `&tags[${i}]=${tag.value}`
      })
      let subCategories = ''
      this.categories.forEach((category, i) => {
        subCategories += `&categories[${i}]=${category.value}`
      })
// filter by contentType
      let subContentType = ''
      this.contentType.forEach((item, i) => {
        subContentType += `&contentType[${i}]=${item.value}`
      })
// filter by roles
      let subRole = ''
      this.roles.forEach((role, i) => {
        subRole += `&roles[${i}]=${role.value}`
      })
      let subCompany = ''
      this.companies.forEach((company, i) => {
        subCompany += `&companies[${i}]=${company.value}`
      })
// filter by time
      let subLastEdited = ''
      this.lastEdited.forEach((item) => {
        if (item.from) {
          subLastEdited += `&from=${item.from}`
        }
        if (item.to) {
          subLastEdited += `&to=${item.to}`
        }
      })
// filter by lastEditors
      let subLastEditors = ''
      this.lastEditors.forEach((editor, i) => {
        subLastEditors += `&authorId[${i}]=${editor.value}`
      })
// status
      let subStatus = ''
      this.status.forEach((status, i) => {
        subStatus += `&status[${i}]=${status.value}`
      })
      this.$eventHub.$emit('load-end')
      let urlString = `${api.URLS.search}&search=${this.search + subLanguages + subContentType + subTag + subCategories + subRole + subCompany + subLastEdited + subLastEditors + subStatus}&page=${page}&size=${limit}&isArticle=true`
      this.$http.get(urlString, api.headersAuthSettings)
        .then((res) => {
          if (res.body.data.success) {
            this.$eventHub.$emit('load-end')
            this.$eventHub.$emit('load-stop')
          } else {
            this.$eventHub.$emit('load-start')
//          this.contentAutoloadInfo.curPage = res.body.current_page_number
            if (page === 1) {
              this.articles = res.body.data.items ? res.body.data.items : []
            } else {
              this.articles = [...this.articles, ...res.body.data.items]
            }
          }
        })
        .catch((err) => {
          this.contentAutoloadInfo.locked = false
          console.log(err)
        })
    },
    searchByParams (page, limit) {
      this.contentAutoloadInfo.curPage = page
      let body = {
        language: this.languages.map((item) => item.value),
        contentType: this.contentType.map((item) => item.value),
        tags: this.tags.map((item) => item.value),
        categories: this.categories.map((item) => item.value),
        roles: this.roles.map((item) => item.value),
        companies: this.companies.map((item) => item.value),
        isArticle: 1,
        authorId: this.lastEditors.map((item) => item.value),
        status: this.status.map((item) => item.value)
      }
      this.lastEdited.forEach((item) => {
        if (item.from) {
          body.from = item.from
        }
        if (item.to) {
          body.to = item.to
        }
      })
      this.$eventHub.$emit('load-end')
      this.$http.post(api.URLS.contentSearch + '?page=' + page + '&limit=' + limit, body, api.headersAuthSettings)
        .then((res) => {
// Set status options
          if (res.body.data.items.length < true) {
            this.$eventHub.$emit('load-end')
            this.$eventHub.$emit('load-stop')
          } else {
            this.$eventHub.$emit('load-start')
          }
          this.statusOptions = []
          let statusOptions = res.body.status ? res.body.status : {}
          Object.keys(statusOptions).forEach(key => {
            this.statusOptions.push({
              label: key,
              value: +statusOptions[key].id
            })
          })
          this.contentAutoloadInfo.curPage = res.body.data.current_page_number
          this.contentAutoloadInfo.numPages = Math.ceil(res.body.data.total_count / limit) !== 0 ? Math.ceil(res.body.data.total_count / limit) : 1
          if (page === 1) {
            this.articles = res.body.data.items
          } else {
            this.articles = [...this.articles, ...res.body.data.items]
          }
// set article count
          let count = res.body.status
          this.statusbar.published = count.Published.count
          this.statusbar.draft = count.Draft.count
          this.statusbar.archived = count.Archived.count
        })
        .catch(() => {
          this.contentAutoloadInfo.locked = false
        })
    },
    getStatus (st) {
      switch (st) {
        case 0:
          return 'Draft'
        case 1:
          return 'Published'
        case 2:
          return 'Archived'
        default:
          return ''
      }
    },
    removeSelectedFilters (filter) {
      console.log(filter)
// Languages
      this.languages.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.languages.splice(i, 1)
          return
        }
      })
      this.contentType.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.contentType.splice(i, 1)
          return
        }
      })
      this.categories.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.categories.splice(i, 1)
          return
        }
      })
      this.tags.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.tags.splice(i, 1)
          return
        }
      })
      this.roles.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.roles.splice(i, 1)
          return
        }
      })
      this.companies.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.companies.splice(i, 1)
          return
        }
      })
// Last edited
      this.lastEdited.forEach((item, i) => {
        if (item.id === null && item.label === filter.label) {
          this.lastEdited.splice(i, 1)
          return
        }
      })
// Last editors
      this.lastEditors.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.lastEditors.splice(i, 1)
          return
        }
      })
// Status
      this.status.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.status.splice(i, 1)
          return
        }
      })
    },
    removeAllFilters () {
      this.languages = []
      this.contentType = []
      this.categories = []
      this.tags = []
      this.roles = []
      this.companies = []
      this.lastEdited = []
      this.lastEditors = []
      this.status = []
    },
    convertDate (payload, delimetr) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
    },
    changeDateFilter () {
//      this.datepicker.isShown = false
      this.showHideSubMenu(7)
      if (!this.datepicker.from && !this.datepicker.to) return
      let label = (this.datepicker.from ? this.convertDate(this.datepicker.from, '.') : 'n/a') +
        ' - ' + (this.datepicker.to ? this.convertDate(this.datepicker.to, '.') : 'n/a')
      this.lastEdited = [{
        label,
        id: null,
        from: this.datepicker.from ? convertDate(this.datepicker.from, '-') : null,
        to: this.datepicker.to ? convertDate(this.datepicker.to, '-') : null
      }]
      function convertDate (payload, delimetr) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        return fullYear + delimetr + toDoubleDigit(month) + delimetr + toDoubleDigit(day)
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
      }
    },
    getOptionsLastEditors (search, loading) {
      loading(true)
      let body = {
        name: search
      }
      this.$http.post(api.URLS.usersSearch, body, api.headersAuthSettings)
        .then((res) => {
          console.log(res)
          let users = res.body.items ? res.body.items : []
          this.lastEditorsOptions = users.map(user => {
            return {
              value: user.id,
              label: user.username + ' ' + user.last_name
            }
          })
          loading(false)
        })
        .catch((err) => {
          console.log(err)
          loading(false)
        })
    },
    initSearch () {
      this.search ? this.mainSearch(1, 20) : this.searchByParams(1, 20)
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    isExist (element) {
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    articleRoles (roles) {
      let string = ''
      roles.forEach(role => {
        string += role.name + '</br>'
      })
      return string
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    }
  },
  computed: {
    ...mapGetters([
      'types',
      'getCategoriesTitle',
      'getTagTitles',
      'getContentTypeForSelect',
      'getTagsForSelect',
      'getCategoriesForSelect',
      'getRolesForSelect',
      'getCompaniesForSelect',
      'getLanguagesForSelect'
    ]),
    selectedFilters () {
      return [...this.languages, ...this.contentType, ...this.categories, ...this.tags, ...this.roles, ...this.companies, ...this.lastEdited, ...this.lastEditors, ...this.status]
    }
  },
  watch: {
    languages () {
      this.initSearch()
    },
    contentType () {
      this.initSearch()
    },
    categories () {
      this.initSearch()
    },
    tags () {
      this.initSearch()
    },
    roles () {
      this.initSearch()
    },
    companies () {
      this.initSearch()
    },
    lastEdited () {
      this.initSearch()
    },
    lastEditors () {
      this.initSearch()
    },
    status () {
      this.initSearch()
    },
    'confirmation.isShown' (value) {
      if (value) {
        this.confirmation.style.top = window.pageYOffset - 100 + 'px'
      }
    }
  },
  components: {
    AppSelect,
    'articleId': articleId,
    'searchInArticles': searchInArticles,
    'languageArticles': languageArticles,
    'typeArticles': typeArticles,
    'topicsArticle': topicsArticle,
    'categoryArticles': categoryArticles,
    'accessArticle': accessArticle,
    'companySpecificArticles': companySpecificArticles,
    'lastEditedArticles': lastEditedArticles,
    'uploaderEditorArticles': uploaderEditorArticles,
    'statusArticles': statusArticles,
    'actionsArticles': actionsArticles
  },
  mounted () {
    let self = this
    this.$eventHub.$on('in-view', function () {
      self.handleScroll()
    })
    this.getTypes()
    this.searchByParams(1, 20)
    this.getCategories()
    this.getCompanies()
    this.getRoles()
    this.getTags()
    this.getLngs()
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>



// WEBPACK FOOTER //
// ArticlesList.vue?57c2484e